//src/app/features/questionnaires/components/QuestionnaireSubTabs/index.tsx
import {
  ArrowDownIcon,
  CheckedIcon,
  QuestionnairesIcon,
  WarningIcon,
} from 'assets/icons';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Route, Routes, useLocation } from 'react-router-dom';
import {
  BaseQuestionnaireRoute,
  expandSubTab,
  selectQuestionnaireRoutes,
  toggleSubTab,
} from '../../edit/routes/slice';
import SubNavItem from '../SubNavItem';

export interface IQuestionnaireSubTabsProps {}
type SubRoute = BaseQuestionnaireRoute | any;

export default function QuestionnaireSubTabs(
  props: IQuestionnaireSubTabsProps,
) {
  const dispatch = useDispatch();
  const location = useLocation();
  const storeQuestionnaireRoutes = useSelector(selectQuestionnaireRoutes);

  const onToggle = (path: string) => {
    dispatch(toggleSubTab(path));
  };

  useEffect(() => {
    const pathLength = location?.pathname?.split('/').slice(4, -1).length;
    const path = location?.pathname?.split('/').slice(4, -1).join('.');
    if (pathLength && pathLength > 1 && path) {
      dispatch(expandSubTab(path));
    }
  }, [location]);

  return (
    <div
      className="flex flex-col h-full relative p-4 border-gray-800 border-r"
      style={{}}
    >
      <Routes>
        {Object.values(storeQuestionnaireRoutes.routes).map((route) => {
          const { path, title, isValid, ...rest } = route;
          const subRoutes: SubRoute = rest;

          return (
            <Route
              key={title}
              path={`${path}/*`}
              element={
                <>
                  <div className="flex flex-col flex-1">
                    {subRoutes &&
                      Object.values(subRoutes).map((subRoute: SubRoute) => {
                        const {
                          path: subRoutePath,
                          title,
                          isValid,
                          toggle,
                          ...subTabs
                        } = subRoute;
                        return (
                          <React.Fragment key={subRoutePath}>
                            {Object.values(subTabs).length ? (
                              <h2
                                onClick={() =>
                                  onToggle(`${path}.${subRoutePath}`)
                                }
                                className="text-xs py-2 font-semibold flex cursor-pointer items-center justify-between"
                              >
                                {title}{' '}
                                {toggle ? (
                                  <ArrowDownIcon />
                                ) : (
                                  <ArrowDownIcon
                                    style={{ transform: 'rotate(270deg)' }}
                                  />
                                )}
                              </h2>
                            ) : (
                              <NavLink
                                to={subRoutePath}
                                className={({ isActive }) =>
                                  isActive
                                    ? 'py-2 rounded-md text-green text-xs font-semibold flex cursor-pointer items-center justify-between'
                                    : 'py-2 rounded-md text-xs font-semibold flex cursor-pointer items-center justify-between'
                                }
                              >
                                {title}
                                {isValid === true && (
                                  <CheckedIcon className="w-4 h-4" />
                                )}
                                {isValid === false && (
                                  <div className="text-red-200">
                                    <WarningIcon className="w-4 h-4" />
                                  </div>
                                )}
                              </NavLink>
                            )}
                            <div className="mb-4">
                              {toggle &&
                                subTabs &&
                                Object.values(subTabs).map((item: any) => {
                                  const {
                                    path: itemPath,
                                    title,
                                    isValid,
                                  } = item;
                                  return (
                                    <SubNavItem
                                      key={`${subRoutePath}/${itemPath}`}
                                      icon={QuestionnairesIcon}
                                      name={title}
                                      path={`${subRoutePath}/${itemPath}`}
                                      isValid={isValid}
                                    />
                                  );
                                })}
                            </div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                </>
              }
            />
          );
        })}
      </Routes>
    </div>
  );
}
